import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { rootRoute } from '../../../config';
import { motion } from "framer-motion";
import { play_simulation, save_userData } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import Button from '../../common/Button'
import SimProgress from './SimProgress';
import CalProfitLoss from './CalProfitLoss';
import TotalUnitsGraph from './TotalUnitsGraph';
import UnitsBySuppliersGraph from './UnitsBySuppliersGraph';
import { useOutletContext } from "react-router-dom";
import ScmModuleStyle from '../styles/scm.module.css';
import info from '../assets/info.png';
import ReactDOM from 'react-dom';
import GraphDataTable from './GraphDataTable';
import BidsOrders from './BidsOrders';
import warning from "../assets/warning.png";
import pluralize from 'pluralize';

const Simulation = () => {
  const [quantity, setQuantity] = useState(50);
  const [shippingType, setShippingType] = useState("NORMAL_SHIPPING");
  const [simPopup,setSimPopup,isOverlay,setIsOverlay,headerPopup,setHeaderPopup,isArtifacts,setIsArtifacts,plPopup,setPlPopup,ulPopup,setUlPopup,simPrgPopup,setSimPrgPopup,skipWalkThruPopups,isPopupShown,setIsPopupShown,accordionPopup,setAccordionPopup,simObj,setSimObj,getMonth,toggleSimulation,setToggleSimulation,startOverSimulation,isLoader,setIsLoader,setAriaProperty,check_Location,setError,error,simType,isWaitForMoreBids, setIsWaitForMoreBids,scmPopup,setScmPopup,viewBidsPopup,setViewBidsPopup, setRelaunchPopup,focusPopUp, isModalVisible, setIsModalVisible] = useOutletContext();
  const [isDecisionPopup, setIsDecisionPopup] = useState(false);
  const [isShowRequestBid, setIsShowRequestBid] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [point, setPoint] = useState(null);
  const [pOrderActivityHeight, setPOrderActivityHeight] = useState(0);
  const [activeBidOrderTab,setActiveBidOrderTab] = useState("request bid");
  const [seriesStatus,setSeriesStatus]=useState([]);
  const [scmGraphsTop,setScmGraphsTop]=useState(0);
  const [isBidOrderOpen, setIsBidOrderOpen] = useState(true);
  const [userDataInfo, setUserDataInfo] = useState(false);
  const [periodicalType, setPeriodicalType] = useState("first");
  const [scmKpisTop, setScmKpisTop] = useState(0);
  const [scmGraph1Top, setScmGraph1Top] = useState(0);
  const isUserInput = useRef(false);
  const [inputValue, setInputValue] = useState("");
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change
  const [isToggledTotalUnitsPopup, setIsToggledTotalUnitsPopup] = useState(false);
  const inValidInputStyle = {
    color: 'rgb(185, 0, 0)'
  }
  const showDecisionPopup = () => {
    setIsDecisionPopup(true);
  }
  const hideDecisionPopup = () => {
    setIsDecisionPopup(false);
    var element = document.getElementById('RevenueGraph-Quality');
    element.style.overflow = 'hidden';
  }
  const loadNextPoup = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setIsPopupShown(true);
    if (document.querySelector(".help-link") != null) {
      document.querySelector(".help-link").focus();
    }
  }

  const getUserData = (data,num) => {
    if(num == 1){
      return pluralize(data,1)
    }
    else{
      return pluralize(data,2)
    }
  }
  const saveUserData = (a)=> {
    let userData = a =="save" ? document.getElementById("userData").value : "gizmo";
    save_userData({
      "id":simObj?.id,
      "executioninstanceid": simObj?.executioninstanceid,
      "attemptno": simObj?.attemptno,
      "userData": userData
    }).then((response)=>{
      if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
        setError(response?.data)
      }
    else{
      if (typeof response != 'undefined') {
        if(response?.data?.valid){
          setSimObj(response.data);
          // window.$('.ui.tiny.modal.user-input').modal('hide');
          setIsModalVisible(false);
          window.$('.my-dimmer .ui.dimmer').dimmer("hide");
        }
        else{
          setUserDataInfo(response?.data)
        }  
      }
    }
    }).catch(()=>{
      // setError(errorMsg);
      setError({"id":"00000","msg":errorMsg})
    })
  }

  const playSimulation = () => {
    setTimeout(() => {
      setToggleSimulation(true);
    }, 0);
    /*
    var profitLossElements = document.getElementsByClassName("profit-loss");
    var currentdaysElements = document.getElementsByClassName("currentdays");
    for (var i = 0; i < profitLossElements.length; i++) {
        profitLossElements[i].setAttribute("role", "alert");
    }
    for (var i = 0; i < currentdaysElements.length; i++) {
      currentdaysElements[i].setAttribute("role", "alert");
    }
    */
  }

  const resumeSimulation = () => {
    // let runSimObj = {}
    // for (let key in simObj) {
    //   if (!window.$.isArray(simObj[key])) {
    //     runSimObj[key] = simObj[key]
    //   }
    // }
    if (!isRequestLoading) {
      setIsRequestLoading(true);
      let copySimObj = {...simObj};
      delete copySimObj.artifacts;
      delete copySimObj.graphdata;
      delete copySimObj.supplierInformations;
      delete copySimObj.supplierDetails;
      play_simulation(copySimObj?.sessionid, copySimObj).then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        if (typeof response != 'undefined') {
          //trigger when isReceived Bid
          let dtiObj = {
            bid: {isBidReceived: false,isWaitForMoreBids: false,trigger:'All',artifactid_id:null},
            quality: {isQualityIssue: false,trigger:'All',artifactid_id:null},
            delivery: {isDeliveryIssue: false,trigger:'All',artifactid_id:null},
            labour: {isLabourIssue: false,trigger:'All',artifactid_id:null}
          }
          let artifacts = response?.data?.artifacts.filter((artifact) => (artifact.md == "EMAILS" && artifact.rs == 0) && (artifact.val.classification == "BID_RESPONSE" || artifact.val.classification == "QUALITY_ISSUE" || artifact.val.classification == "DELIVERY_ISSUE" || artifact.val.classification == "LABOUR_ISSUE")).sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr))
          let currentArtifactObj = artifacts[0];
          console.log(currentArtifactObj)
          if (artifacts.length > 0) {
            switch (currentArtifactObj.val.classification) {
              case "BID_RESPONSE":
                if (response?.data?.laststate?.isBidReceived) {
                  dtiObj.bid['isWaitForMoreBids'] = response?.data?.laststate?.requestedBidList?.length >= 1;
                  dtiObj.bid['isBidReceived'] = true;
                  dtiObj.bid['trigger'] = currentArtifactObj?.val?.trigger;
                  dtiObj.bid['artifactid_id'] = currentArtifactObj?.aii;
                  
                  if (!isWaitForMoreBids || response?.data?.laststate?.requestedBidList?.length <= 0) {
                    window.$(".email-link")[0]?.click();
                    setIsWaitForMoreBids(false);
                  }
          
                  setTimeout(() => {
                    window.$("li#" + currentArtifactObj.aii)[0]?.click();
                  }, 200);
                }
                break;
          
              case "QUALITY_ISSUE":
                dtiObj.quality['isQualityIssue'] = true;
                dtiObj.quality['trigger'] = currentArtifactObj?.rvalues?.sender;
                dtiObj.quality['artifactid_id'] = currentArtifactObj?.aii;
                
                window.$(".email-link")[0]?.click();
                setTimeout(() => {
                  window.$("li#" + currentArtifactObj.aii)[0]?.click();
                }, 200);
                break;
          
              case "DELIVERY_ISSUE":
                dtiObj.delivery['isDeliveryIssue'] = true;
                dtiObj.delivery['trigger'] = currentArtifactObj?.rvalues?.sender;
                dtiObj.delivery['artifactid_id'] = currentArtifactObj?.aii;
                
                window.$(".email-link")[0]?.click();
                setTimeout(() => {
                  window.$("li#" + currentArtifactObj.aii)[0]?.click();
                }, 200);
                break;
          
              case "LABOUR_ISSUE":
                dtiObj.labour['isLabourIssue'] = true;
                dtiObj.labour['trigger'] = currentArtifactObj?.rvalues?.sender;
                dtiObj.labour['artifactid_id'] = currentArtifactObj?.aii;
                
                window.$(".email-link")[0]?.click();
                setTimeout(() => {
                  window.$("li#" + currentArtifactObj.aii)[0]?.click();
                }, 200);
                break;
          
              default:
                // Handle other cases if needed
                break;
            }
          }          
          const _graphdata=[{
                "currentRampValue": 6,
                "currentRampDate":response?.data?.laststate?.currentRampDate,
                "stateday": response?.data?.laststate?.stateday,
                "statemonth": response?.data?.laststate?.statemonth,
                "quarter": 1,
                "weekNumbers": 1,
                "supplierOrderDetails": {
                  "Component1": [],
                  "Component2": []
                },
                "requiredComponent1PerWeek": response?.data?.laststate?.requiredComponent1PerWeek,
                "requiredComponent2PerWeek": response?.data?.laststate?.requiredComponent2PerWeek,
                "totalComponent1receivedOrdersUnits": 0,
                "totalComponent2receivedOrdersUnits": 0,
                "totalComponent1remainingUnits": 0,
                "totalComponent2remainingUnits": 0
              }]
          let newSimObj = {
            ...response?.data,
            ['dtiObj']: dtiObj,
            ['graphdata']: (response?.data?.graphdata?.length == 0) ? _graphdata : response?.data?.graphdata
          }
          setSimObj(newSimObj);
          setIsShowRequestBid(false);
          setIsRequestLoading(false);
        }
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      })
    }
  }

  const pauseSimulation = () => {
    setToggleSimulation(false);
    /*
    var profitLossElements = document.getElementsByClassName("profit-loss");
    var currentdaysElements = document.getElementsByClassName("currentdays");
    for (var i = 0; i < profitLossElements.length; i++) {
      profitLossElements[i].removeAttribute("role");
    }
    for (var i = 0; i < currentdaysElements.length; i++) {
      currentdaysElements[i].removeAttribute("role");
    }
    console.log("pasuse:" + simObj.currentstep)
    */
  }
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    console.log("readcount:" + readStatusLength)
    if (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != undefined) {
      skipWalkThruPopups(false);
    }
  }
  const initSimulation = () => {
    if (!isPopupShown) {
      setIsOverlay(true);
      setHeaderPopup(true)
    }
    setIsArtifacts(true);
  }

  const handleToggleTotalUnitsPopup = (event) => {
     setIsToggledTotalUnitsPopup((prev) => !prev);
  };
  
  const handleKeyDownTotalUnitsPopup = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault(); // stop page scroll on Space
      handleToggleTotalUnitsPopup();
    }
  };
  window.$(document).on("click", function(e){
      if(!window.$(e.target).closest('#totalUnitsPopup').length > 0){
      setIsToggledTotalUnitsPopup(false);
      }
  });

  useEffect(() => {
    initSimulation();
    window.$('.ui.accordion').accordion();
    window.$('html, body').animate({
      scrollTop: 0
    }, 100);
    // document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
    document.title = "Supply Chain Management | Simulation";
    document.querySelector("header.header h1.title").focus();
    document.querySelector(".skip-to-main-content-link").style.display = "block";
    if (document.querySelector("#showSummary")) {
      document.querySelector("#showSummary").focus();
    }
    return () => {
      document.querySelector(".skip-to-main-content-link").style.display = "none";
    }
  }, []);

  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  useEffect(() => {
    fuSkipWalkThruPopups();
    // console.log(simObj)
  }, [simObj])

  const functionTabGraphControl = () => {
    class TabsManual {
      constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          this.tabpanels.push(tabpanel);

          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));

          if (!this.firstTab) {
            this.firstTab = tab;
          }
          this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
      }

      setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            //this.tabpanels[i].classList.remove('is-hidden');
          } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            //this.tabpanels[i].classList.add('is-hidden');
          }
        }
      }

      moveFocusToTab(currentTab) {
        currentTab.focus();
      }

      moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
          this.moveFocusToTab(this.lastTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index - 1]);
        }
      }

      moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
          this.moveFocusToTab(this.firstTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index + 1]);
        }
      }

      /* EVENT HANDLERS */

      onKeydown(event) {
        var tgt = event.currentTarget,
          flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.moveFocusToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.moveFocusToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.moveFocusToTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.moveFocusToTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Since this example uses buttons for the tabs, the click onr also is activated
      // with the space and enter keys
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }
    // window.addEventListener('load', function () {
    //   var tablists = document.querySelectorAll('[role=tablist].Graphs');
    //   for (var i = 0; i < tablists.length; i++) {
    //     new TabsManual(tablists[i]);
    //   }
    //   if(document.querySelectorAll('.Graphs button') != null){
    //     const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
    //     elementsWithClassGraphs.forEach(element => {
    //         if (element.getAttribute('aria-selected') === 'false') {
    //             element.setAttribute('tabindex', '-1');
    //         }
    //     });
    //   }
    // });
    const initTabs = () => {
      var tablists = document.querySelectorAll('[role=tablist].Graphs');
      for (var i = 0; i < tablists.length; i++) {
        new TabsManual(tablists[i]);
      }
      if (document.querySelectorAll('.Graphs button') != null) {
        const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
        elementsWithClassGraphs.forEach(element => {
          if (element.getAttribute('aria-selected') === 'false') {
            element.setAttribute('tabindex', '-1');
          }
        });
      }
    }
    initTabs()
  }
  useEffect(() => {
    functionTabGraphControl();
  }, [])

  useEffect(() => {
    if(viewBidsPopup && !document.querySelector(".ui.accordion .title").classList.contains("active")){
      window.$(".ui.accordion .title").click();
    }
  }, [viewBidsPopup])

  useEffect(()=>{
    if(scmPopup?.scmGraphs && document.querySelector(".ui.pointing.label") != null){
      let top = document.querySelector(".ui.pointing.label").clientHeight + 30
      setScmGraphsTop(-top)
    }
  },[scmPopup?.scmGraphs])

  useEffect(() => {
    const handleResize1 = ()=> {
          if(scmPopup?.unitsGraph && document.querySelector(".ui.pointing.label") != null){
            let top = document.querySelector(".ui.pointing.label").clientHeight - 8;
            if(window.innerWidth <= 440){
              top = top - 35;
            }
            else if(window.innerWidth <= 768 && window.innerWidth >= 440){
              top = top + 20;
            }
            setScmGraph1Top(-top);
          }

          if(scmPopup?.scmKpis && document.getElementsByClassName("ui pointing label")[0] != null){
            let top = document.getElementsByClassName(`${ScmModuleStyle['profit-loss']}`)[0].offsetTop + document.getElementsByClassName(`${ScmModuleStyle['profit-loss']}`)[0].clientHeight;
            setScmKpisTop(top); 
          }
    }
    window.addEventListener('resize', handleResize1);
    handleResize1();
  }, [scmPopup?.unitsGraph,scmPopup?.scmKpis]);

  useEffect(()=>{
    if(window.innerWidth <= 360 && scmPopup?.deliveryStatus){
     let target = document.getElementsByClassName(`${ScmModuleStyle['bids-from-supplier']}`)[0];
     target.scrollTo(500,0)
    }
},[scmPopup?.deliveryStatus])
  const openNewWindow = (data) => {
    const newWindow = window.open('', '_blank', 'width=800,height=800');
    if (newWindow) {
      newWindow.document.open();
      const htmlContentWithNbsp = `
<!DOCTYPE html>
<html>
<head>
    <title>Quality Management</title>
    <link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css">
    <style>
          .MainDiv {
              min-height: 620px;
              overflow: hidden;
              width: 95%;
              margin: 0 auto;
          }
          .MainDivChild {
              overflow-x: auto;
              margin: 10px auto;
          }
          table.dataTable thead th {
            border: 1px solid rgba(0, 0, 0, 0.3);
            background-color: #f0f0f0;
          }
          .dataTables_length {
              min-width: 5.5em;
              padding: 10px;
          }
          .dataTables_filter {
            min-width: 5.5em;
            padding: 10px;
            text-align: left;
          }
          .table {
              width: 100%;
              max-width: 100%;
              margin-bottom: 20px;
          }
          .headingh3 {
              color: #002D5F;
              font-weight: 700;
              font-size: 22px;
              background: transparent;
              padding: 0;
          }
          header.header {
            box-shadow: 0px 1px 2px 0px #CCCCCC;
            color: #012F61;
            position: relative;
          }
          header.header>.container {
            margin: 0px 20px;
            display: flex;
            justify-content: space-between;
            min-height: 60px;
            align-items: center;
          }
          header.header>.container h1 {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #b2347b;
          }
          table.dataTable thead th {
              color: #002D5F;
          }
          .header-container header {
          font-size: 12px;
          color: #b2347b;
          }
          .footer {
              background-color: #CDCDCD;
              font-size: 12px;
              padding: 6px;
              text-align: center;
              color: #000000;
          }
          .footer .container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 82.5%;
              margin: auto;
          }
          .footer .container>div {
              display: flex;
          }
          .footer-links {
              list-style-type: none;
              padding-left: 0;
              padding: 0 5px;
              margin: 0;
              display: flex;
          }
          .footer-links .listitem a {
              text-decoration: underline;
              color: #000000;
          }
          #RevenueGraphData th {
            padding: 4px; 
          }
          #RevenueGraphData tr td:first-child {
            width: 45px; 
          }
    </style>
</head>
<body style="font: 16px/26px 'Roboto', 'Helvetica Neue', Helvetica, Arial; -webkit-font-smoothing: antialiased; font-weight: 300;margin:0;">
<div id="new-component-root"></div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        $('#RevenueGraphData').DataTable({
            pagingType: 'full_numbers'
        });
        $('#FailureGraphData').DataTable({
            pagingType: 'full_numbers'
        });
    });
</script>
</body>
</html>
`;
      const htmlContentWithoutNbsp = htmlContentWithNbsp.replace(/&nbsp;/g, ' ');


      newWindow.document.write(htmlContentWithoutNbsp);
      ReactDOM.render(<GraphDataTable type={periodicalType} simObj={simObj} setSimObj={setSimObj} />, newWindow.document.getElementById("new-component-root"));
      newWindow.document.close();
    }
  };

// Reset the user input field to the default placeholder
function resetUserDataInput() {
  window.$('.user-data-input').val(''); // Clear the input field
  window.$('.user-data-input').attr('placeholder', 'Gizmos'); // Reset placeholder
}

// Listen for the custom event to reset the input
document.addEventListener('resetUserDataInput', resetUserDataInput);


  window.$(document).off('click touchstart', '.custom-modal .ui.btn_cancel.button').on('click touchstart','.custom-modal .ui.btn_cancel.button', function(e) {
    e.stopPropagation();
    saveUserData("skip");
  });
  window.$(document).off('click touchstart', '.custom-modal .ui.btn_approve.button').on('click touchstart','.custom-modal .ui.btn_approve.button', function(e) {
    e.stopPropagation();
    saveUserData("save");
  });
  // useEffect(() => {
  //   if((simObj?.hasOwnProperty("userData") && simObj?.userData == "") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
  //     if(window.$(".ui.dimmer .user-input").length > 1){
  //       window.$(".ui.dimmer .user-input:last").remove();
  //     }
  //     window.$('.ui.tiny.modal.user-input').modal({
  //       closable: false 
  //     }).modal('show');
  //     isUserInput.current = true;
  //     // setIsUserInputPopup(false);
  //   }
  // },[simObj]);

  // useEffect(()=>{
  //   if(simObj?.hasOwnProperty("userData") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
  //     if(isUserInput.current){
  //       if(window.$(".ui.dimmer .user-input").length > 0){
  //         focusPopUp(".user-input");
  //         document.querySelector(".user-input input").removeAttribute("tabindex");
  //         document.querySelector(".user-input input").focus();
  //         document.querySelectorAll(".user-input button").forEach((item)=>{
  //             item.removeAttribute("tabindex")
  //         });
  //       }
  //     }
  //   }
  // },[simObj,isUserInput.current])

  useEffect(()=>{
    if(simObj?.hasOwnProperty("userData") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
        setTimeout(() => {
          if(simObj?.userData == ""){
            if(document.querySelector(".ui.pointing.label")){
              document.querySelectorAll(".ui.pointing.label button").forEach((item)=>{
                item.setAttribute("tabindex","-1");
              })
            }
          }
          else{
            if(document.querySelector(".ui.pointing.label")){
              document.querySelectorAll(".ui.pointing.label button").forEach((item)=>{
                item.removeAttribute("tabindex");
              })
              document.querySelector(".ui.pointing.label").setAttribute("tabindex","0");
              document.querySelector(".ui.pointing.label").focus();
            }
          }
          
        }, 100);
    }
  },[simObj?.userData])

  useEffect(() => {
    if((simObj?.hasOwnProperty("userData") && simObj?.userData == "") && (simObj?.hasOwnProperty("version") && simObj?.version > 1) && headerPopup){
      setIsModalVisible(true);
      window.$('.my-dimmer .ui.dimmer').dimmer({
        closable: false // Prevent closing when clicked
      }).dimmer('show');
      isUserInput.current = true;
    }
  }, [simObj, headerPopup]);

  useEffect(() => {
    if (isModalVisible) {
      if (document.querySelector('.custom-modal')) {
        focusPopUp(".custom-modal");
        document.querySelector(".custom-modal input").removeAttribute("tabindex");
          document.querySelector(".custom-modal input").focus();
          document.querySelectorAll(".custom-modal button").forEach((item)=>{
              item.removeAttribute("tabindex")
          });
      }
    }
  }, [isModalVisible]);

  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };
    checkStyleTag();
    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);


  return (
    <motion.div className={`${ScmModuleStyle.simulation} ${ScmModuleStyle.container}`} id={`${isStyleTagPresent ? `${ScmModuleStyle['scmStylus']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${ScmModuleStyle.introtext}`}>
        <h2 className={`${ScmModuleStyle.heading} ${ScmModuleStyle.bgpurple} ${ScmModuleStyle.imSim}`}>Simulation</h2>
        <p>Your goal is to deliver {formatNum(simObj?.laststate?.totalGizmosToBeCompleted != undefined ? simObj?.laststate?.totalGizmosToBeCompleted : 0)} {(simObj?.userData && simObj?.userData!="") ? pluralize(simObj?.userData,2) : "gizmos"} and keep your procurement costs under ${formatNum(simObj?.laststate?.totalBudget != undefined ? simObj?.laststate?.totalBudget : 0)}. There are several different meters to judge how well you are doing.</p>
        {/* Click &nbsp;
        <Link to={`${rootRoute}/${simType?.toLowerCase()}?from=simulation`} style={{'color':'#000','text-decoration':'underline','font-weight':'bold'}}>
          <em className="info circle icon" aria-hidden="true" role="presentation"></em>
          <span>here</span>
        </Link>
        &nbsp;to revisit the tutorial.</p> */}
      </div>
      <CalProfitLoss popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, accordionPopup, setAccordionPopup, simObj, setSimObj, formatNum, toggleSimulation, scmPopup, setScmPopup, setRelaunchPopup]} return getUserData={getUserData}/>
      {
          scmPopup?.scmKpis ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['scm-kpis-popup']}`} role='dialog' aria-modal="true" aria-label="Key Performance Indicators popup" tabIndex={-1} style={{top:scmKpisTop+"px"}}>
            <p>Keep an eye on these Key Performance Indicators (KPIs) to know how well you’re doing against the goal.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['scmKpis'] : false}));
                setRelaunchPopup(true)
              }} />
            </div>
          </div> : ''
        }
      <hr aria-hidden="true" role="presentation" />
      <div className={`${ScmModuleStyle['activities']}`}>
        <SimProgress actions={[playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation, isShowRequestBid]} popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading,scmPopup,setScmPopup,viewBidsPopup,setViewBidsPopup]} />
        <div className={`${ScmModuleStyle['make-decision-activity']} ${scmPopup?.bidsOrder || scmPopup?.bidsFromsupplier? `show ${ScmModuleStyle['show']}` : ''}`} style={{ minHeight: pOrderActivityHeight }}>
          <BidsOrders pOrderActivityHeight={pOrderActivityHeight} setPOrderActivityHeight={setPOrderActivityHeight} simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} getMonth={getMonth} setIsShowRequestBid={setIsShowRequestBid} skipWalkThruPopups={skipWalkThruPopups} scmPopup={scmPopup} setScmPopup={setScmPopup} activeBidOrderTab={activeBidOrderTab} setActiveBidOrderTab={setActiveBidOrderTab} isOverlay={isOverlay} isBidOrderOpen={isBidOrderOpen} setIsBidOrderOpen={setIsBidOrderOpen}/>
        </div>
        {
          scmPopup?.bidsOrder ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['bids-order-popup']}`} role='dialog' aria-modal="true" aria-label="Bids orders popup" tabIndex={-1}>
            {
            isBidOrderOpen ? <p>When you’re ready, you can request bids here. Click the (i) icon to learn about each supplier who can supply each SKU. Note that some bids cost money. Check the box for the suppliers you want bids from, then click Request Bids.</p> : <p>When you’re ready, you can request bids by expanding the Bids/Orders menu using the arrow and viewing the REQUEST BID menu. Click the (i) icon to learn about each supplier who can supply each SKU. Note that some bids cost money. Check the box for the suppliers you want bids from, then click Request Bids.</p>
          }
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['bidsOrder'] : false, ['simProgPopup'] : true}))
              }} />
            </div>
          </div> : ''
        }
        {
          scmPopup?.bidsFromsupplier ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['bids-order-popup']}`} role='dialog' aria-modal="true" aria-label="Bids from suppliers details popup" tabIndex={-1}>
            <p>You will see any bids summarized here and can input an order quantity, which will automatically calculate an order cost. Keep an eye on the delivery date. You can also add Rush Delivery for an extra fee if you need to. When you’re satisfied with your order amount for your chosen supplier(s), click Place Order.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['bidsFromsupplier'] : false, ['deliveryStatus'] : true}))
              }} />
            </div>
          </div> : ''
        }
        {
          scmPopup?.deliveryStatus ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['delivery-status-popup']}`} role='dialog' aria-modal="true" aria-label="Delivery status popup" tabIndex={-1}>
            <p>You will see whether the suppliers are In Progress of filling your order or Awaiting an Order after supplying a bid. If any issues arise with these orders, you can cancel them here too.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['deliveryStatus'] : false, ['scmGraphs'] : true}))
              }} />
            </div>
          </div> : ''
        }
      </div>
      {/* <div className={`${ScmModuleStyle['simmsg-container']}`}>
        {
          (
            ((toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowRequestBid)
             || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && isShowRequestBid) 
             || (simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming)
             || (!(toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && !isShowRequestBid && (simObj.status == 'COMPLETED'))) && <div className={`ui success message ${ScmModuleStyle.ui} ${ScmModuleStyle.success} ${ScmModuleStyle.message} ${ScmModuleStyle.simmsg}`}>
            <div role='alert'>
              { simObj.currentstep != 0 && <img src={info} />}
              { 
                (toggleSimulation && simObj.status != 'COMPLETED' && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length!=0) && <p>{`Pause the simulation to make a new decision.`}</p>
              }
              {
                !(toggleSimulation) && (isShowRequestBid) && <p className='placeorder-msg'>{`Your investment decisions are saved, please click on ${simObj?.currentstep > 0 ? 'Resume' : 'Start'} Simulation to continue.`}</p>
              }
              {                
                (simObj.status != 'COMPLETED') &&  simObj.currentstep != 0 && (!(toggleSimulation) && !(isShowRequestBid) && simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length > 0 && simObj?.laststate?.investmentOptions?.isUpcomming) && <p>{`Please review and make investment decisions and click on Resume Simulation.`}</p>
              }
              {
                (simObj.status == 'COMPLETED') && <p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p>
              }
            </div>
          </div>
        }
      </div> */}
      {/* <hr className={`${ScmModuleStyle['mt0']}`} aria-hidden="true" role="presentation" /> */}
     
      <div className={` ${ScmModuleStyle['graph-parent']}`}>
      {
          scmPopup?.scmGraphs ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['scm-graphs-popup']}`} role='dialog' aria-modal="true" aria-label="Graphs popup" tabIndex={-1} style={{top:`${scmGraphsTop}px`}}>
            <p>These graphs are useful for tracking how well you’re doing with your ordering of each SKU.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['scmGraphs'] : false, ['unitsGraph'] : true}))
              }} />
            </div>
          </div> : ''
        }
      <div className={`${ScmModuleStyle['options']} ${scmPopup?.scmGraphs ? `show ${ScmModuleStyle['show']}` : ''}`}>
        <div className={ScmModuleStyle['action-buttons']}>
          <div className="tabs">
            <div role="tablist" aria-labelledby="Rev-Cost" className="Graphs">
              <button
                className={`quarter1 ui button ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']} ${periodicalType === "first" ? ScmModuleStyle['active'] : ''}`}
                type="button"
                role="tab"
                onClick={() => { setPeriodicalType("first") }}
                style={{
                  color: periodicalType === "first" ? "#B90000" : "black",
                  transition: "border-bottom 0.2s",
                  borderBottom: periodicalType === "first" ? "2px solid #B90000" : "",
                  padding: "4px 11px",
                  borderRadius: 0
                }}
                aria-selected={periodicalType === 'first'}
                //tabindex={periodicalType === 'first' ? "0" : "-1"}
                aria-controls="tabpanel-1"
                id="tab-1"
              >
                First Quarter
              </button>
              <button
                className={`quarter2 ui button ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']} ${periodicalType === "second" ? ScmModuleStyle['active'] : ''}`}
                type="button"
                role="tab"
                onClick={() => { setPeriodicalType("second") }}
                style={{
                  color: periodicalType === "second" ? "#B90000" : "black",
                  transition: "border-bottom 0.2s",
                  borderBottom: periodicalType === "second" ? "2px solid #B90000" : "",
                  padding: "4px 11px",
                  borderRadius: 0
                }}
                aria-selected={periodicalType === 'second'}
                //tabindex={periodicalType === 'second' ? "0" : "-1"}
                aria-controls="tabpanel-2"
                tabIndex="-1"
                id="tab-2"
              >
                Second Quarter
              </button>
              <button
                className={`quarter3 ui button ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']} ${periodicalType === "third" ? ScmModuleStyle['active'] : ''}`}
                type="button"
                role="tab"
                onClick={() => { setPeriodicalType("third") }}
                style={{
                  color: periodicalType === "third" ? "#B90000" : "black",
                  transition: "border-bottom 0.2s",
                  borderBottom: periodicalType === "third" ? "2px solid #B90000" : "",
                  padding: "4px 11px",
                  borderRadius: 0
                }}
                aria-selected={periodicalType === 'third'}
                //tabindex={periodicalType === 'third' ? "0" : "-1"}
                tabIndex="-1"
                aria-controls="tabpanel-3"
                id="tab-3"
              >
                Third Quarter
              </button>
              <button
                className={`quarter4 ui button ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']} ${periodicalType === "fourth" ? ScmModuleStyle['active'] : ''}`}
                type="button"
                role="tab"
                onClick={() => { setPeriodicalType("fourth") }}
                style={{
                  color: periodicalType === "fourth" ? "#B90000" : "black",
                  transition: "border-bottom 0.2s",
                  borderBottom: periodicalType === "fourth" ? "2px solid #B90000" : "",
                  padding: "4px 11px",
                  borderRadius: 0
                }}
                aria-selected={periodicalType === 'fourth'}
                //tabindex={periodicalType === 'fourth' ? "0" : "-1"}
                tabIndex="-1"
                aria-controls="tabpanel-4"
                id="tab-4"
              >
                Fourth Quarter
              </button>
              <a onClick={() => openNewWindow()} aria-hidden="true" tabIndex="-1" className="sr-only">Open a table version of graphdata</a>
            </div>
          </div>
        </div>
      </div>
      {
          scmPopup?.unitsGraph ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['graph1-popup']}`} role='dialog' aria-modal="true" aria-label="Total number of Units graph popup" tabIndex={-1} style={{top: scmGraph1Top+"px"}}>
            <p>This graph summarizes all SKUs delivered and provides guideline of how many of each SKU is required each week to stay on track.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['unitsGraph'] : false, ['unitBySupplierGraph'] : true}))
              }} />
            </div>
          </div> : ''
        }
      <div className={`${ScmModuleStyle['graph-wrapper']} ${scmPopup?.scmGraphs ? `show ${ScmModuleStyle['show']}` : ''}`} role="tabpanel" aria-labelledby={periodicalType == "first" ? "tab-1" : periodicalType == "second" ? "tab-2" : periodicalType == "third" ? "tab-3" : "tab-4"} id={periodicalType === "first" ? "tabpanel-1" : periodicalType === "second" ? "tabpanel-2" : periodicalType === "third" ? "tabpanel-3" : periodicalType === "fourth"  && "tabpanel-4"}> 
        <div className={`${ScmModuleStyle['_graph']} ${scmPopup?.unitsGraph ? `show ${ScmModuleStyle['show']}` : ''}`} id="TotalUnits">
          <h3 id="heading-totalUnits">Total No. of Units
            {/* <span className={`${ScmModuleStyle['totalunit-tooltip']}`}> */}
            {/* <a onClick={(e)=>e.preventDefault()} href="#" data-tooltip="This graph shows your total order quantity for each SKU. Compare your total orders to the required weekly delivery to ensure you are on track to meet your goal." data-position="bottom left">
              <img src={warning} alt="" />
            </a> */}
            <a id="totalUnitsPopup" className={`${ScmModuleStyle["totalUnitsAnchor"]}`} href="#" role="button" tabIndex={0} aria-label="Info about Total Units" 
                          onClick={(e) => {
                            e.preventDefault();
                            handleToggleTotalUnitsPopup();
                          }} 
                          onKeyDown={handleKeyDownTotalUnitsPopup}
                          onMouseEnter={()=> {
                          if(window.innerWidth > 991) {
                              setIsToggledTotalUnitsPopup(true);
                          }
                          }}
                          onMouseLeave={()=> {
                          if(window.innerWidth > 991) {
                              setIsToggledTotalUnitsPopup(false);
                          }
                          }}
                          onBlur={()=> setIsToggledTotalUnitsPopup(false)}><img src={warning} alt="" /></a>
                      <div className={`ui fluid popup bottom center transition ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup} ${ScmModuleStyle["total-units-popup"]}`} style={{ display: isToggledTotalUnitsPopup == true ? "block" : "none" }}>
                          <p role="alert" aria-live="assertive">This graph shows your total order quantity for each SKU. Compare your total orders to the required weekly delivery to ensure you are on track to meet your goal.</p>
                      </div>
          {/* </span> */}
          </h3>
          {/* <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} /> */}

          <TotalUnitsGraph type={periodicalType} simObj={simObj} setSimObj={setSimObj} seriesStatus={seriesStatus} setSeriesStatus={setSeriesStatus}/>
          <div className={`${ScmModuleStyle['totalunits-legends']}`}>
            <div className={`${ScmModuleStyle['units-delivered']}`}>
              <div><span className={`${ScmModuleStyle['totalunit-legend1']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true"><div className={`${ScmModuleStyle['legend-sign1']}`}></div></span>
                <span>SKU1 units delivered</span></div>
              <div><span className={`${ScmModuleStyle['totalunit-legend2']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true"><div className={`${ScmModuleStyle['legend-sign2']}`}></div></span>
                <span>SKU2 units delivered</span></div>
            </div>

            <div className={`${ScmModuleStyle['units-delivered']}`}>
              <div><span className={`${ScmModuleStyle['line-center']}`}><span className={`${ScmModuleStyle['totalunit-legend1']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#9481;</span>
                <div>Required weekly delivery</div></span></div>
              <div><span className={`${ScmModuleStyle['line-center']}`}><span className={`${ScmModuleStyle['totalunit-legend2']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#9481;</span>
                <div>Required weekly delivery</div></span></div>
            </div>
          </div>


          {/* <div className={`${ScmModuleStyle['costquality-legends']}`} aria-hidden="true">
            <div className={`${ScmModuleStyle['container-div']}`}>
              <div className={`${ScmModuleStyle['circle-line']}`}></div>
              <div className={`${ScmModuleStyle['horizontal-line-circle']}`}></div>  
            </div>
            <span>Revenue</span>
            <div className ={`${ScmModuleStyle['container-div']}`}>
            <div className ={`${ScmModuleStyle['horizontal-line-rhombus']}`}></div>
            <div className ={`${ScmModuleStyle['rhombus']}`}></div>
            <div className ={`${ScmModuleStyle['circle-rhombus']}`}></div>
            </div>
            <span>Cost of Quality</span>
          </div> */}
          {/* <div className={`${ScmModuleStyle['inventorygraph-legend']}`} aria-hidden="true"><span className={`${ScmModuleStyle['inventory-legend']} ${ScmModuleStyle['inventorypattern']}`}>&#8226;</span>Inventory</div> */}
          {/* <InventoryGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} /> */}
        </div>
        <span className={`${ScmModuleStyle['seprater']}`}></span>
        <div className={`${ScmModuleStyle['_graph']} ${scmPopup?.unitBySupplierGraph ? `show ${ScmModuleStyle['show']}` : ''}`} id="SupplierUnits">
          <h3 id="heading-unitsSupplier">Units by Supplier</h3>
          {/* <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} /> */}
          <UnitsBySuppliersGraph type={periodicalType} simObj={simObj} setSimObj={setSimObj}/>
          <div className={`${ScmModuleStyle['totalunits-legends']}`}>
            <div className={`${ScmModuleStyle['units-delivered']}`}>
              <div><span className={`${ScmModuleStyle['totalunit-legend1']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#9632;</span>
                <span>SKU1 units delivered</span></div>
              <div><span className={`${ScmModuleStyle['totalunit-legend2']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#9632;</span>
                <span>SKU2 units delivered</span></div>
            </div>

            <div className={`${ScmModuleStyle['units-delivered']}`}>
              <span className={`${ScmModuleStyle['line-center']}`}><span className={`${ScmModuleStyle['totalunit-legend1']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#9723;</span>
                <div>Pending units</div></span>
              <span className={`${ScmModuleStyle['line-center']}`}><span className={`${ScmModuleStyle['totalunit-legend2']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#9723;</span>
                <div>Pending units</div></span>
            </div>
            <div className={`${ScmModuleStyle['units-delivered']}`}>
              <span className={`${ScmModuleStyle['line-center']}`}><span className={`${ScmModuleStyle['noDelivery-legend']} ${ScmModuleStyle['totalunitpattern']}`} aria-hidden="true">&#127348;</span>
                <div>No delivery this week</div></span>
            </div>
          </div>

        </div>
        {
          scmPopup?.unitBySupplierGraph ? <div className={`ui pointing label Arcgraph2-popup ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['graph2-popup']}`} role='dialog' aria-modal="true" aria-label="Units by supplier graph popup" tabIndex={-1}>
            <p>This graph shows the units pending (ordered) and delivered of each SKU by each supplier.</p>
            <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setScmPopup((prevScmPopup) => ({...prevScmPopup, ['unitBySupplierGraph'] : false, ['gizmosProcKpis'] : true}))
              }} />
            </div>
          </div> : ''
        }
      </div>
      </div>
      {/* <div role={"dialog"} className={`ui tiny modal user-input ${ScmModuleStyle["ui"]} ${ScmModuleStyle["tiny"]} ${ScmModuleStyle["modal"]} ${ScmModuleStyle["user-input"]}`}>
        <table className={`ui unstackable table ${ScmModuleStyle["ui"]} ${ScmModuleStyle["unstackable"]} ${ScmModuleStyle["table"]}`} role='presentation'>
            <tbody>
              <tr>
                <td className={`${ScmModuleStyle["label"]}`} aria-hidden="true"><label htmlFor="userData" id="userDataLabel">Change Product Name</label></td>
                <td>
                  <div className={`ui input left aligned`}>
                    <input type="text" placeholder="gizmos" id="userData" className="user-data-input" autoComplete='off' aria-labelledby="userDataLabel"/>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td></td>
                <td className={`actions left aligned ${ScmModuleStyle["actions"]}`}>
                  <Button btnName={"Skip"} btnClass={`btn_cancel ${ScmModuleStyle["btn_cancel"]}`}/>
                  <Button btnName={"Save"} btnClass={`btn_approve ${ScmModuleStyle["btn_approve"]}`}/>
                </td>
              </tr>
              {
                (userDataInfo && userDataInfo?.valid==0) && 
                <tr style={inValidInputStyle}>
                  <td colSpan={2}>{userDataInfo?.message}</td>
                </tr>
              }
            </tbody>
        </table>
      </div> */}
      {isModalVisible && (
        <>
        <div role={"dialog"} className={`custom-modal ${ScmModuleStyle["custom-modal"]}`} aria-labelledby="userDataLabel">
          <table className={`custom-table ${ScmModuleStyle["custom-table"]}`} role='presentation'>
              <tbody>
                <tr>
                  <td className={`${ScmModuleStyle["label"]}`} aria-hidden="true">
                    <label htmlFor="userData" id="userDataLabel">Change Product Name</label>
                  </td>
                  <td>
                    <div className={`custom-input ${ScmModuleStyle["custom-input"]}`}>
                      <input type="text" placeholder="gizmos" id="userData" className="user-data-input" autoComplete='off' aria-labelledby="userDataLabel" value={inputValue} onChange={(e) => setInputValue(e.target.value)}/>
                    </div>
                  </td>
                </tr>
                
                <tr>
                  <td></td>
                  <td className={`actions left aligned ${ScmModuleStyle["actions"]}`}>
                    <Button btnName={"Skip"} btnClass={`btn_cancel ${ScmModuleStyle["btn_cancel"]}`} />
                    <Button btnName={"Save"} btnClass={`btn_approve ${ScmModuleStyle["btn_approve"]}`}/>
                  </td>
                </tr>
                {
                  (userDataInfo && userDataInfo?.valid==0) && 
                  <tr style={inValidInputStyle}>
                    <td colSpan={2}>{userDataInfo?.message}</td>
                  </tr>
                }
              </tbody>
          </table>
        </div>
      </>)}
    </motion.div>

  )
}

export default Simulation